import { render } from "./Information.vue?vue&type=template&id=69d50ea8&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"

import "./Information.vue?vue&type=style&index=0&id=69d50ea8&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d50ea8"]])

export default __exports__